import { HTTP_INTERCEPTORS, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { catchError, filter, retry, switchMap, take } from 'rxjs/operators';
import { AuthService } from './auth.service';
const TOKEN_HEADER_KEY = 'Authorization';
@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private _isRefreshing = false;
  private _refreshTokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  constructor(private _authService: AuthService) { }
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<Object>> {
    let authReq = req;
    const token = this._authService.accessToken;
    if (token != null) {
      authReq = this._addTokenHeader(req, token);
    }
    return next.handle(authReq).pipe(catchError(error => {
      if (error instanceof HttpErrorResponse && !authReq.url.includes('auth/signup') && error.status === 401) {
        return this._handle401Error(authReq, next);
      }
      console.warn('Internal Error');
      return undefined
      // return next.handle(req).pipe(retry(2));
    }));
  }
  private _handle401Error(request: HttpRequest<any>, next: HttpHandler) {
    if (!this._isRefreshing) {
      this._isRefreshing = true;
      this._refreshTokenSubject.next(null);
      const token = this._authService.refreshToken;
      console.log(token, 'this._authService.refreshToken in auth interceptor');      
      
      if (token)
        return this._authService.refreshTokenResolver().pipe(
          switchMap((token) => {
            console.log(token, 'auth interceptor in pipe use refreshTokenResolver');
            
            this._isRefreshing = false;
            this._authService.accessToken = token.access;
            this._refreshTokenSubject.next(token.access);
            return next.handle(this._addTokenHeader(request, token.access));
          }),
          catchError((err) => {
            this._isRefreshing = false;
            this._authService.logout();
            console.warn('Refresh Token is Expire');
            return throwError(err);
          })
        );
    }
    return this._refreshTokenSubject.pipe(
      filter(token => token !== null),
      take(1),
      switchMap((token) => next.handle(this._addTokenHeader(request, token)))
    );
  }
  private _addTokenHeader(request: HttpRequest<any>, token: string) {
      return request.clone({
          setHeaders: {
            [TOKEN_HEADER_KEY]: 'Bearer ' + token,
          }
      })
    // return request.clone({ headers: request.headers.set(TOKEN_HEADER_KEY, 'Bearer ' + token) });
  }
}
export const authInterceptorProviders = [
  { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true }
];